import { useEffect } from "react";

const ensureMeta = (name, content, attr = "name") => {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const ensureCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const useSeo = ({ title, description, canonical, schema }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      ensureMeta("description", description);
      ensureMeta("og:description", description, "property");
    }
    if (title) ensureMeta("og:title", title, "property");
    if (canonical) {
      ensureCanonical(canonical);
      ensureMeta("og:url", canonical, "property");
    }

    let script;
    if (schema) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-schema";
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
    };
  }, [title, description, canonical, schema]);
};
